var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRpRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 51,
    viewBox: "0 0 10 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.6 0L5.2 0.45L9.2 3.45L8 5.05L5.6 3.25L5.6 47.25L8 45.45L9.2 47.05L5.2 50.05L4.6 50.5L4 50.05L0 47.05L1.2 45.45L3.6 47.25L3.6 3.25L1.2 5.05L0 3.45L4 0.45L4.6 0Z",
    fill: "#DD1919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRpRed);
export default __webpack_public_path__ + "static/media/RPRed.81bbf599362cf4e5078f032eb491dd94.svg";
export { ForwardRef as ReactComponent };